// dependencies
import { fromJS } from "immutable";

export default fromJS({
	deployments: [],
	branches: [],
	fuzzyBranches: null,
});
